export const breadcrumb = {
  title: 'HLR',

  requests: {
    index: 'Request'
  }
};
